var map = {
	"./Colchester.TTF": 795,
	"./Felix.TTF": 796,
	"./FuturaBold.TTF": 797,
	"./FuturaLight.TTF": 798,
	"./MinionPro-Regular.otf": 799,
	"./Mr-Darcy-Bold.ttf": 800,
	"./Mr-Darcy-Regular.ttf": 801,
	"./Roboto-Italic.ttf": 802,
	"./Roboto-Medium.ttf": 803,
	"./Roboto-MediumItalic.ttf": 804,
	"./Roboto-Regular.ttf": 805,
	"./earthorbiter.ttf": 806,
	"./earthorbiterbold.ttf": 807,
	"./times new roman bold italic.ttf": 808,
	"./times new roman bold.ttf": 809,
	"./times new roman italic.ttf": 810,
	"./times new roman.ttf": 811
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 794;